import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageFatherA.module.scss";

function PageFatherA() {
  const getImgSet = useImgSet();

  const notice = getImgSet("notice__p22", "png");
  const item01 = getImgSet("item__01__p22", "png", [s.item, s.item__01]);
  const item02 = getImgSet("item__02__p22", "png", [s.item, s.item__02]);
  const item03 = getImgSet("item__03__p22", "png", [s.item, s.item__03]);
  const pointer = getImgSet("pointer__father", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__01", "png", s.img__a);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        {imgA}
        <Link to="/father/b" className={s.notice}>
          {notice}
        </Link>
      </div>
      <div className={s.inner}>
        {item01}
        {item02}
        {item03}
      </div>
      <div className={s.aside_right}>
        <Link to="/father/" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutOptions(PageFatherA);
